import Emitter from "tiny-emitter";

export const emitter = new Emitter();
window.em = emitter;


export const EmitterEvents = {
    UpdateBalance: "updateBalance",

    ExpressionAdded: "expressionAdded",

    TriggerEvent: "triggerEvent",

    AddNotification: "addNotification",
    RemoveNotification: "removeNotification",


    broadcastFinishOnboarding: "broadcastFinishOnboarding",
}
